<template>
  <a-date-picker
    :open="open"
    mode="year"
    format="YYYY"
    @panelChange="onPanelChange"
    @openChange="onOpenChange"
    placeholder="选择年份"
    @change="onChange"
    v-model="defaultValue"
    v-bind="instance"
    style="width:100%"
  />
</template>

<script>
import moment from 'moment'
export default {
  props: {
    instance: Object
  },
  data () {
    return {
      open: false,
      defaultValue: null
    }
  },
  watch: {
    instance: {
      handler(nVal) {
        Object.assign(this, { ...nVal }) // 把传入的参数，融合到this中
        console.log('this', this)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    onPanelChange(v) {
      this.defaultValue = v
      this.$emit('change', moment(v).format("YYYY"))
      this.open = false
    },
    onOpenChange(v) {
      if(v) {
        this.open = true
      } else {
        this.open = false
      }
    },
    onChange() {
      this.defaultValue = null
      this.$emit('change', undefined) //点击清空按钮重置日期
    }
  }
}
</script>
